import ButtonGroup from '@components/common/ButtonGroup/ButtonGroup.component'
import { marketingOverviewFilter } from '@dataTypes/marketing.type'
import React, { useCallback } from 'react'
import './OverviewFilterStyle.css'

interface OverviewProps {
  activeFilter: marketingOverviewFilter
  onRefresh: () => void
  setFilter: (dateFilter: marketingOverviewFilter) => void
}

const OverviewFilter: React.FC<OverviewProps> = ({
  activeFilter,
  setFilter,
}) => {
  const handleChangeTab = useCallback(
    async (newFilter: string) => {
      setFilter(newFilter as marketingOverviewFilter)
    },
    [setFilter],
  )

  return (
    <div className="mo-button-container">
      <ButtonGroup
        buttons={Object.values(marketingOverviewFilter).map((filter) => ({
          label: filter,
          value: filter,
        }))}
        activeTab={activeFilter}
        onButtonClick={handleChangeTab}
      />
    </div>
  )
}

export default OverviewFilter
